import { V2StaticLegislationBriefing } from '../../components/static-legislation-briefing/V2StaticLegislationBriefing'
import { V2ProductRegulationPageShell } from './V2ProductRegulationPageShell'

type V2ProductFgasRegulationPageProps = {
  productId: string
}

export function V2ProductFgasRegulationPage({
  productId,
}: V2ProductFgasRegulationPageProps) {
  return (
    <V2ProductRegulationPageShell productId={productId} law="fgas">
      {(applies) => <V2StaticLegislationBriefing law="fgas" applies={applies} />}
    </V2ProductRegulationPageShell>
  )
}
